export default __webpack_public_path__ + "static/article-lets-keep-healthy-over-christmas-e7602d999c53003fcda3f3ddb6531e99.jpg";